import { useParams } from 'react-router';
import { StatementDetail } from './StatementDetail';

/** /settlements/statements/:id：手机 push 页、桌面整页；?v=doc 打开明细版 */
export function StatementDetailPage() {
  const { id } = useParams();
  return <StatementDetail key={id} id={id!} />;
}
